import { render } from "./MatchPickerV2.vue?vue&type=template&id=752eea60&scoped=true"
import script from "./MatchPickerV2.vue?vue&type=script&lang=js"
export * from "./MatchPickerV2.vue?vue&type=script&lang=js"

import "./MatchPickerV2.vue?vue&type=style&index=0&id=752eea60&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752eea60"]])

export default __exports__